// modified daniel.silva - we don't have active subscription, we have to manually import fontawesome-pro
//import '@fortawesome/fontawesome-pro/css/all.min.css'
import "./fontawesome/fontawesome-pro/css/all.min.css";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "vuetify/styles";
import { aliases, fa } from "vuetify/iconsets/fa";

//import colors from 'vuetify/es5/util/colors'
// Our own translation file
import en from "../locale/en.ts";
import es from "../locale/es.ts";
import pt from "../locale/pt.ts";
import nl from "../locale/nl.ts";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "myLight",
    themes: {
      myLight: {
        colors: {
          primary: process.env.VUE_APP_VUETIFY_PRIMARY,
          secondary: process.env.VUE_APP_VUETIFY_SECONDARY,
          accent: process.env.VUE_APP_VUETIFY_ACCENT,
          error: process.env.VUE_APP_VUETIFY_ERROR,
          warning: process.env.VUE_APP_VUETIFY_WARNING,
          info: process.env.VUE_APP_VUETIFY_INFO,
          success: process.env.VUE_APP_VUETIFY_SUCCESS,
        },
      },
      myDark: {
        dark: true,
        colors: {
          primary: process.env.VUE_APP_VUETIFY_PRIMARY,
          secondary: process.env.VUE_APP_VUETIFY_SECONDARY,
          accent: process.env.VUE_APP_VUETIFY_ACCENT,
          error: process.env.VUE_APP_VUETIFY_ERROR,
          warning: process.env.VUE_APP_VUETIFY_WARNING,
          info: process.env.VUE_APP_VUETIFY_INFO,
          success: process.env.VUE_APP_VUETIFY_SUCCESS,
        },
      },
    },
  },
  options: {
    minifyTheme: function (css) {
      return process.env.NODE_ENV === "production"
        ? css.replace(/[\s|\r\n|\r|\n]/g, "")
        : css;
    },
  },
  customProperties: true,
  icons: {
    defaultSet: "fa",
    aliases: aliases,
    sets: {
      fa,
    },
  },
  locale: {
    locale: process.env.VUE_APP_LANG,
    fallback: "en",
    messages: { pt, en, es, nl },
    rtl: {
      customLocale: true,
    },
  },
  defaults: {
    VTextField: {
      variant: "underlined",
    },
    VSelect: {
      variant: "underlined",
    },
    VCheckbox: {
      trueValue: 1,
    },
  },
});

export { vuetify };
